import React, { useContext, useEffect, useState } from "react";
import { IonPage, IonLoading, IonContent, IonLabel,isPlatform } from "@ionic/react";
import { abpLogout } from "../api/abpLogin";
import { getApiSession } from "../util/ApiOptionsHelper";
import { reactPlugin } from "../util/AppInsights";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { useIonAlert } from "@ionic/react";
import { TranslationsContext,TranslationMessagesContext } from "../util/Translations";

const EndSession: React.FC = () => {
  const { translatedMessages } = useContext(TranslationMessagesContext);
  const [presentAlert] = useIonAlert();
  const [showLoading, setShowLoading] = useState(true);
  const [error, setError] = useState<any>(null);
  const [labelText, setLabelText] = useState("Your session is being terminated...");
  const { translations } = useContext(TranslationsContext);
  const [showConfirm, setShowConfirm] = useState(true);
  const [portalFrontEndUrl, setPortalFrontEndUrl] = useState<string | null>(null); // State to store the URL
  const [shouldEndSession, setShouldEndSession] = useState(false);

  useEffect(() => {
    fetch("/authConfig.json")
      .then((response) => response.json())
      .then((config) => {
        const url = config[0]?.WEB?.PORTAL_FRONTEND_URL;
        if (url) {
          setPortalFrontEndUrl(url);
        } else {
          console.error("PORTAL_FRONTEND_URL not found in authConfig.json");
        }
      })
      .catch((error) => {
        console.error("Failed to load authConfig.json:", error);
      });
  }, []);

  useEffect(() => {
    const isPWA = !isPlatform("hybrid");
    if (showConfirm && isPWA) {
      presentAlert({
        header: translatedMessages["ConfirmSessionEnd"]?.MessageId || "ConfirmSessionEnd",
        message: translatedMessages["ConfirmSessionEnd"]?.MessageText || "Exiting this application will end your session, which may also log you out of other open applications in this browser. Do you want to continue?",
        buttons: [
          {
            text: translations["lbl_btn_no"] || "No",
            role: "cancel",
            handler: () => {
              setShowConfirm(false);
              window.location.href = "/home";
            },
          },
          {
            text: translations["lbl_btn_yes"] || "Yes",
            role: "confirm",
            handler: () => {
              setShowConfirm(false);
              setShouldEndSession(true);
            },
          },
        ],
      });
    } else if (shouldEndSession || !isPWA) {
      endAbpSession();
    }
  }, [showConfirm, shouldEndSession]);

  async function endAbpSession() {
    try {
      const apiSession = await getApiSession();
      if (!apiSession || !apiSession.LicenseSessionId) {
        handeSessionExpireFailure();
        return;
      }
      const response = await abpLogout();
      const isPWA = !isPlatform("hybrid");
      if (response.status === 200) {
        if (isPWA && portalFrontEndUrl) {
          const iframe = document.getElementById("iframeBroadcast") as HTMLIFrameElement;
          if (iframe && iframe.contentWindow) {
            const message = {
              type: "EAM_SESSION_END",
              payload: {
                from: "EAM Application",
                data: "Session has ended successfully.",
              },
            };
            const messageTimeout = setTimeout(() => {
              console.log("PostMessage timeout - redirecting to session end");
              window.location.href = "/sessionend.html";
            }, 1000); 
  
            try {
              iframe.contentWindow.postMessage(message, portalFrontEndUrl);
            } catch (error) {
              console.error("Failed to post message:", error);
              clearTimeout(messageTimeout);
              window.location.href = "/sessionend.html";
            }
          } else {
            window.location.href = "/sessionend.html";
          }
        } else {
          window.location.href = "/sessionend.html";
        }
      } else {
        handeSessionExpireFailure();
      }
    } catch (error) {
      handeSessionExpireFailure(error);
    }
  }  
  function handeSessionExpireFailure(error?: any) {
    setLabelText("Failed to terminate session. Please try again.");
    console.error("ABP Logout failed:", error);
    setTimeout(() => {
      window.location.href = "/home";
    }, 3000);
  }

  return (
    <IonPage>
      <IonLoading
        isOpen={true}
        backdropDismiss={false}
        duration={5000}
      />
      <IonContent className="ion-padding">
        <IonLabel>{labelText}</IonLabel>
      </IonContent>
    </IonPage>
  );
};

export default withAITracking(reactPlugin, EndSession, "EndSession");